module.exports = __webpack_public_path__ + "static/media/40x40-12.1b330733.png";